<template>
    <section class="resume-section experience-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">{{translations.title}}</h2>
        <div class="resume-section-content">
            <div class="resume-timeline position-relative">
                <article v-for="(event, index) in events" :key="index"
                         class="resume-timeline-item position-relative pb-5"
                >
                    <div class="resume-timeline-item-header mb-2">
                        <div class="d-flex flex-column flex-md-row">
                            <h3 class="resume-position-title font-weight-bold mb-1">{{translations[event.function]}}</h3>
                            <div class="resume-company-name ml-auto">{{companies[event.company].name}}</div>
                        </div>
                        <div class="resume-position-time">{{event.from}} - {{event.to || translations.present}}</div>
                    </div>
                    <div class="resume-timeline-item-desc">
                        <span v-html="event.resume[lang]"></span>
                        <template v-if="event.goals.length">
                            <h4 class="resume-timeline-item-desc-heading font-weight-bold">
                                {{translations.goals}}:</h4>
                            <ul>
                                <li v-for="(goalKey, gIndex) in event.goals" :key="gIndex">
                                    {{translations[goalKey] + (gIndex === event.goals.length-1 ? "." : ";")}}
                                </li>
                            </ul>
                        </template>
                        <template v-if="event.technologies.length">
                            <h4 class="resume-timeline-item-desc-heading font-weight-bold">
                                {{translations.technologies}}:</h4>
                            <ul class="list-inline">
                                <li v-for="(technology, tIndex) in event.technologies" :key="tIndex"
                                    class="list-inline-item"
                                >
                                    <span class="badge badge-primary badge-pill">{{technology}}</span>
                                </li>
                            </ul>
                        </template>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: "Timeline",
        computed: {
            lang() {
                return this.$store.state.config.lang;
            },
            translations() {
                return this.$store.state.timeline.i18n[this.lang];
            },
            companies() {
                return this.$store.state.timeline.companies;
            },
            events() {
                return this.$store.state.timeline.events;
            },
            data() {
                return this.$store.state.timeline[this.$store.state.config.lang];
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "./../../sass/constants"
    .resume
        &-timeline
            padding-left: 2rem

            &:before
                content: ""
                display: inline-block
                width: 3px
                height: 100%
                background: $light-green
                left: 6px
                top: 4px
                position: absolute

            &-item
                &-desc-heading
                    font-size: 1rem

                &:before
                    content: ""
                    display: inline-block
                    position: absolute
                    left: -32px
                    top: 3px
                    width: 15px
                    height: 15px
                    border: 4px solid $bright-green
                    background: $white
                    border-radius: 50%

        &-company-name
            color: $dead-blue
            font-size: 0.875rem
            font-weight: 500

        &-position
            &-time
                font-size: 0.875rem
                color: $light-blue

            &-title
                font-size: 1.125rem
                color: $gray-blue


</style>